import { AsyncPipe, DatePipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { MatBadge } from '@angular/material/badge'
import { MatFormField, MatHint, MatLabel } from '@angular/material/form-field'
import { MatInput } from '@angular/material/input'
import { MatTab, MatTabContent, MatTabGroup, MatTabLabel } from '@angular/material/tabs'
import {
  ElderFormFieldLabelDirective,
  ElderLabelInputComponent,
  ElderPaneComponent,
  ElderPaneContentComponent,
  ElderPaneHeaderComponent,
  ElderPaneTitleComponent,
  IsoDurationPipe,
  TimeAgoPipe,
} from '@elderbyte/ngx-starter'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { Duration, ZonedDateTime } from '@js-joda/core'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { BehaviorSubject } from 'rxjs'
import { Bom } from '../bom/bom'
import { BomEditorComponent } from '../bom/bom-editor/bom-editor.component'
import { BomPropertySetDetailComponent } from '../bom/bom-property-set-detail/bom-property-set-detail.component'
import { WorkItemSegment } from '../work-item'

@Component({
  selector: 'app-item-work-segment',
  templateUrl: './item-work-segment.component.html',
  styleUrls: ['./item-work-segment.component.scss'],
  imports: [
    ElderPaneComponent,
    ElderPaneHeaderComponent,
    ElderPaneContentComponent,
    ElderPaneTitleComponent,
    MatTabGroup,
    MatTab,
    MatFormField,
    ElderFormFieldLabelDirective,
    MatLabel,
    MatInput,
    FormsModule,
    ElderLabelInputComponent,
    MatHint,
    BomPropertySetDetailComponent,
    MatTabLabel,
    MatBadge,
    MatTabContent,
    BomEditorComponent,
    AsyncPipe,
    DatePipe,
    ElderTranslatePipe,
    TimeAgoPipe,
    IsoDurationPipe,
  ],
})
export class ItemWorkSegmentComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly logger = LoggerFactory.getLogger(this.constructor.name)

  public readonly segment$ = new BehaviorSubject<WorkItemSegment>(null)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {}

  /***************************************************************************
   *                                                                         *
   * Getters / Setters                                                       *
   *                                                                         *
   **************************************************************************/

  @Input()
  public set segment(segment: WorkItemSegment) {
    if (segment?.consumptionBom) {
      Bom.populateNamed(segment.consumptionBom)
    }

    if (segment?.finishedBom) {
      Bom.populateNamed(segment.finishedBom)
    }

    if (segment?.productModel) {
      Bom.populateNamed(segment.productModel)
    }

    this.segment$.next(segment)
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public getActualMakeSpan(segment: WorkItemSegment): Duration {
    const startedAt = segment.processingAudit?.startedAt
    const completedAt = segment.processingAudit?.completedAt
    if (!startedAt || !completedAt) {
      return Duration.ZERO
    } else {
      return Duration.between(ZonedDateTime.parse(startedAt), ZonedDateTime.parse(completedAt))
    }
  }

  /***************************************************************************
   *                                                                         *
   * Private methods                                                         *
   *                                                                         *
   **************************************************************************/
}
